export const LOADER = 'UPDATE_LOADER'
export const MODAL = 'UPDATE_MODAL'
export const SELECTED_ACTIVITY = 'UPDATE_SELECTED_ACTIVITY'
export const RESET_ACTIVITY_DATA = 'UPDATE_RESET_ACTIVITY_DATA'
export const USER_DATA = 'UPDATE_USER_DATA'
export const COMPANY_SETTINGS = 'UPDATE_COMPANY_SETTINGS'
export const ROLE_RIGHTS = 'UPDATE_ROLE_RIGHTS'
export const COMPANY_TAX = 'UPDATE_COMPANY_TAX'
export const LOGIN = 'LOGIN'
export const BRANCH_CONFIGURATION = 'BRANCH_CONFIGURATION'
export const GET_POLICY_RIGHTS = 'GET_POLICY_RIGHTS'

export const SEARCH_LR_Data = 'SEARCH_LR_Data'
export const Admin_Common_LR_Data = 'Admin_Common_LR_Data'
export const Modify_Data = 'Modify_Data'
export const lrDetails_data = 'lrDetails_data'
export const ADD_NEW_MODIFY_ROW = 'ADD_NEW_MODIFY_ROW'
export const REMOVE_MODIFY_ROW = 'REMOVE_MODIFY_ROW'
export const Recharge_List = 'Recharge_List'
export const Recharge_Party_List = 'Recharge_Party_List'

export const Recharge_Payment_List = 'Recharge_Payment_List'

export const Server_Date_Time = 'Server_Date_Time'

export const CITY_LIST = 'UPDATE_CITY_LIST'
export const STRT_CITY_LIST = 'UPDATE_STRT_CITY_LIST'
export const DEST_CITY_LIST = 'UPDATE_DEST_CITY_LIST'
export const BRANCH_LIST = 'UPDATE_BRANCH_LIST'
export const STRT_BRANCH_LIST = 'UPDATE_SEND_BRANCH_LIST'
export const ADMIN_BRANCH_LIST = 'ADMIN_BRANCH_LIST'

export const DEST_BRANCH_LIST = 'UPDATE_DEST_BRANCH_LIST'

export const STRT_CITY = 'UPDATE_STRT_CITY'
export const DEST_CITY = 'UPDATE_DEST_CITY'
export const STRT_BRNCH = 'UPDATE_STRT_BRNCH'
export const DEST_BRNCH = 'UPDATE_DEST_BRNCH'
export const BOOKING_TYPE = 'UPDATE_BOOKING_TYPE'
export const BOOKED_PNR_DATA = 'BOOKED_PNR_DATA'
export const FOC_APPROV_LIST = 'FOC_APPROV_LIST'
export const BRANCH_CREDIT_LIMIT = 'BRANCH_CREDIT_LIMIT'
export const DEST_BRANCH_CREDIT_LIMIT = 'DEST_BRANCH_CREDIT_LIMIT'
export const LAST_LR = 'LAST_LR'
export const EWB_AUTH_DETAILS = 'EWB_AUTH_DETAILS'
export const ADD_EWB_DETAILS = 'ADD_EWB_DETAILS'
export const REMOVE_EWB_DETAILS = 'REMOVE_EWB_DETAILS'
export const RESET_EWB_DETAILS = 'RESET_EWB_DETAILS'

export const PARTY_LIST = 'UPDATE_PARTY_LIST'
export const OTP_REQ = 'OTP_REQUEST'
export const PARTY = 'UPDATE_PARTY'
export const OTP_Detail = 'UPDATE_OTP_DETAIL'
export const CONSIGNMENT_TYPES = 'UPDATE_CONSIGNMENT_TYPES'
export const METHOD_OF_PACKING_TYPES = 'UPDATE_METHOD_OF_PACKING_TYPES'
export const CONSIGNMENT_TYPE = 'UPDATE_CONSIGNMENT_TYPE'
export const METHOD_OF_PACKING_TYPE = 'UPDATE_METHOD_OF_PACKING_TYPE'

export const SELECTED_LR_NUMBER = 'UPDATE_SELECTED_LR_NUMBER'

export const DEL_SECT_DATA = 'DEL_SECT_DATA'
export const EXTRA_HAMALI = 'EXTRA_HAMALI'
export const DEL_HAMALI = 'DEL_HAMALI'
export const DEMURAGE = 'DEMURAGE'
export const DEL_CARTAGE = 'DEL_CARTAGE'
export const DELIVERY_GST = 'DELIVERY_GST'
export const DISCOUNT = 'DISCOUNT'
export const GET_ID_PROOF = 'GET_ID_PROOF'
export const GET_POST_DELIVERY = 'GET_POST_DELIVERY'
export const GET_PRINT_DELIVERY = 'GET_PRINT_DELIVERY'
export const GET_TICKET_FORMAT = 'GET_TICKET_FORMAT'
export const ALL_PRINT_FORMAT_LIST = 'ALL_PRINT_FORMAT_LIST'
export const SELECTED_FORMAT_DETAIL = 'SELECTED_FORMAT_DETAIL'

export const UPDATE_DETAILS = 'UPDATE_DETAILS'
export const ERROR = 'ERROR'
export const CURRENT_ADDRESS = 'CURRENT_ADDRESS'
export const GMAP_KEY = 'GMAP_KEY'
export const LR_STATUS = 'LR_STATUS'
export const LR_STATUS_Cancel_Trasaction = 'LR_STATUS_Cancel_Trasaction'

export const ALERT = 'ALERT'
export const CANCEL_DELIVERY = 'CANCEL_DELIVERY'

//All types of Branch Transfer
export const VEHICLE_LIST = 'VEHICLE_LIST'
export const DRIVER_INFO_LIST = 'DRIVER_INFO_LIST'
export const DEST_CITIES_BRANCH_LIST = 'UPDATE_DEST_CITIES_BRANCH_LIST'
export const ALL_STATES = 'ALL_STATES'
export const LIST_DATA = 'LIST_DATA'
export const BRANCH_TRANSFER = 'BRANCH_TRANSFER'
export const BRANCH_TRANSFER_CANCEL_LIST = 'BRANCH_TRANSFER_CANCEL_LIST'
export const BRANCH_TRANSFER_CANCEL = 'BRANCH_TRANSFER_CANCEL'
export const PRINT_MEMO = 'RINT_MEMO'
export const CHECKING_REPORT = 'CHECKING_REPORT'
export const UPDATE_TRANSFER = 'UPDATE_TRANSFER'
export const UPDATE_GET_CHALLAN_NUMBER = 'UPDATE_GET_CHALLAN_NUMBER'

export const SEL_PAYMENT_TYPES = 'UPDATE_PAYMENT_TYPES'
export const SEL_SEARCH_BY = 'UPDATE_SEARCH_BY'
export const PRICING_INQUIRY = 'PRICING_INQUIRY'
export const VALIDATE_GSTN = 'VALIDATE_GSTN'
//For Dashboard
export const DASHBOARD_DISPATCH_DETAILS = 'DASHBOARD_DISPATCH_DETAILS'
export const DASHBOARD_BRANCHRECEIVE_DETAILS = 'DASHBOARD_BRANCHRECEIVE_DETAILS'
export const DASHBOARD_RECEIVE_DETAILS = 'DASHBOARD_RECEIVE_DETAILS'

export const DELIVERY_ID_TYPE = 'DELIVERY_ID_TYPE'
export const DELIVERY_ID_NUMBER = 'DELIVERY_ID_NUMBER'
export const DELIVERY_ID_IMG = 'DELIVERY_ID_IMG'
export const PARENT_COMPANY_DATA = `PARENT_COMPANY_DATA`
export const BOOKING_PERMISSION_DATA = `BOOKING_PERMISSION_DATA`
export const CITY_DISTANCE = 'CITY_DISTANCE'
export const BOOKING_REFUND = 'BOOKING_REFUND'

export const GST_CONFIG = 'GST_CONFIG'
export const MODIFY_SECTION_DATA = 'MODIFY_SECTION_DATA'
export const Modify_ROW = 'Modify_ROW'
export const DELIVERY_BOOKINGTYPE_ID = `DELIVERY_BOOKINGTYPE_ID`

// for payment time
export const METHO_OF_PAYMENT = `METHO_OF_PAYMENT`
export const BANK_ACCOUNT_DETAILS = `BANK_ACCOUNT_DETAILS`
export const SET_GOOGLE_APIKEY = 'SET_GOOGLE_APIKEY'

//For Delivery Memo
export const DELIVERY_MEMO_LIST = `DELIVERY_MEMO_LIST`

//report
export const USER_LIST = 'USER_LIST'
export const COMP_CITY_LIST = 'COMP_CITY_LIST'

//weight chrg
export const WEIGHT_CHARGE = 'WEIGHT_CHARGE'

//roll rights
export const SET_ROLL_RIGHTS = 'SET_ROLL_RIGHTS'


export const CITY_BRANCH_MATRIX = 'CITY_BRANCH_MATRIX'
export const FTL_CITY_LIST= 'FTL_CITY_LIST'
export const EWAY_BILL_EXMPTED = 'EWAY_BILL_EXMPTED'
